import { find } from 'lodash';
import * as Constants from 'const';
import * as Models from 'models';
import { isRegularRelation } from 'utils/relations/isRegularRelation';

export function findTextRelationByDocumentId(
  relations: Models.Relations,
  documentId: string,
): Models.RegularRelation<Models.TextRelationStyles> | undefined {
  const relation = find(relations, (entry) => {
    return entry && isRegularRelation(entry) && entry.documentId === documentId;
  });
  if (!relation) {
    return undefined;
  }

  return relation as Models.RegularRelation<Models.TextRelationStyles>;
}

export function findLayeredTextRelationAndLayerByDocumentId(
  layeredRelations: Models.LayeredRelationsMap,
  documentId: string,
): [Models.LayeredRegularRelationMap<Models.TextRelationStyles>, Constants.Layer] | undefined {

  const relation = (layeredRelations
    .filter(isRegularRelation)
    .find((entry: Models.LayeredRegularRelationMap) => entry?.get('documentId').includes(documentId))
  ) as Models.LayeredRegularRelationMap<Models.TextRelationStyles> | undefined;

  if (!relation) {
    return undefined;
  }
  const layer = relation.get('documentId').findKey(id => id === documentId) as Constants.Layer;

  return [relation, layer];
}

export function findLayeredTextRelationByDocumentId(
  relations: Models.LayeredRelationsMap,
  textComponentId: string,
  layer: Constants.Layer,
): Models.LayeredRegularRelationMap<Models.TextRelationStyles> | undefined {
  const relation = relations.find((rel) => {
    if (!rel || !isRegularRelation(rel)) {
      return false;
    }

    return rel?.get('documentId')?.get(layer) === textComponentId;
  });

  return relation as Models.LayeredRegularRelationMap<Models.TextRelationStyles> | undefined;
}
